/** Frontend mirror of functions/src/agentActivityMapping.ts */

const CALENDAR_ACTIONS = new Set([
  'sendTravelChatMessage',
  'listTravelChatMessages',
  'claimTravelChatMessage',
  'getTravelChatThread',
  'postTravelChatReply',
  'failTravelChatMessage',
  'requestTripCalendarSync',
  'listTripCalendarSyncRequests',
  'claimTripCalendarSync',
  'getTripForCalendarSync',
  'submitTripCalendarSyncResult',
  'failTripCalendarSync',
  'executiveCalendarListManagedExecutives',
  'executiveCalendarListCalendars',
  'executiveCalendarListEvents',
  'executiveCalendarInsertEvent',
  'executiveCalendarPatchEvent',
  'executiveCalendarDeleteEvent',
  'executiveCalendarGetDrivingDuration',
  'executiveCalendarInsertEventGroup',
  'executiveCalendarSyncEventGroup',
  'executiveCalendarDeleteEventGroup',
]);

const FILES_ACTIONS = new Set([
  'getLeadDocumentsForAnalysis',
  'upsertAgentAnnotations',
  'upsertDocumentSynopsis',
  'getAgentAnnotationsForAnalysis',
]);

export function resolveDisplayAgentId(agentId: string, action: string): string {
  if (agentId === 'travelAgent') return 'calendarAgent';
  if (CALENDAR_ACTIONS.has(action)) return 'calendarAgent';
  if (FILES_ACTIONS.has(action)) return 'filesAgent';
  return agentId;
}
